<template>
    <rkm-tabs
        :tab-refs="tabRefs"
        v-model="tabIndex"
    >
        <rkm-tab
            title="Dispensação"
        >
            <Dispensacao
                :data="data"
                ref="Dispensacao"
            />
        </rkm-tab>
    </rkm-tabs>
</template>

<script>
import Dispensacao from './components/dispensacao/Form'

export default {
    components: { Dispensacao },
    data: () => ({
        tabIndex: 0,
        tabRefs: [],
    }),
    methods: {
        async validate() {

            const currentValid = await this.tabRefs[this.tabIndex].validate()

            if (!currentValid) {

                return false;
            }

            let valid = true

            for (let i = 0; i < this.tabRefs.length; i++) {

                if (i !== this.tabIndex) {

                    valid = await this.tabRefs[i].validate()

                    if (!valid) {

                        this.tabIndex = i

                        break
                    }
                }
            }

            return valid
        },
    },
    mounted() {

        this.tabRefs = [
            this.$refs.Dispensacao,
        ]
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>